<template>
  <ConfirmModal
    :text="
      $t(
        '_web_round-scheduling_modal-title',
        'Update {round} start date, all further rounds will be rescheduled if needed',
        {
          round: roundName,
        }
      )
    "
    :confirm-button-text="$t('_web_save-label', 'Save')"
    :is-loading="isLoading"
    @cancel="closeModal"
    @confirm="onSave"
  >
    <div class="d-flex flex-row justify-content-center align-items-center mt-6">
      <DateTimePicker
        id="round-schedule-datetime"
        v-model="dateStart"
        :disabled="!canChangeRoundDate"
        class="cursor-pointer"
        :placeholder="
          $t('_web_tournament_match-date-placeholder', 'Select Date')
        "
      >
        <Icon
          slot="prepend-date"
          name="calendar"
          width="18"
          :fill="$scss.heraMuted"
          class="h-mr-3"
        />
        <div slot="prepend-time" class="h-mr-3"></div>
      </DateTimePicker>
    </div>
  </ConfirmModal>
</template>

<script>
import ConfirmModal from '@/components/modal/children/HeraConfirm';
import DateTimePicker from '@/components/form/DateTimePicker';
import Icon from '@/components/atoms/Icon';

import { mapActions } from 'vuex';
import { prop } from '@/utils/factories';

export default {
  name: 'RoundSchedulingModal',
  components: {
    ConfirmModal,
    DateTimePicker,
    Icon,
  },
  props: {
    roundName: prop(String, 'round'),
    round: prop(Object),
    minDate: prop(Number),
    maxDate: prop(Number),
    canChangeRoundDate: prop(Boolean),
  },
  data() {
    return {
      isLoading: false,
      dateStart: this.round.date_start,
    };
  },
  methods: {
    ...mapActions(['closeModal', 'errorNotify', 'updateRoundAction']),
    onSave() {
      this.isLoading = true;
      this.updateRoundAction({
        roundID: this.round.index,
        data: {
          date_start: this.dateStart,
          grid: this.round.grid,
        },
      })
        .then(() => {
          this.$emit('save', this.dateStart);
          this.closeModal();
        })
        .catch(this.errorNotify)
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>

<style></style>
